var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'logo': true, 'playModeScale': _vm.scaleMode == 'playMode'}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo.png")}}),_c('span',[_vm._v("Frogero")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }